<div class="d-flex">
  <div class="me-3">
    <i-feather name="map-pin" class="text-secondary"></i-feather>
  </div>
  <div>
    <div class="mb-2">
      <span class="text-uppercase text-secondary fw-bold">
        Votre recherche :
      </span>
      <span class="ms-3" spanlabeltest-id="spanlabeltest-id">{{
        propertyType.label
      }}</span>
    </div>
    <div>
      <span class="text-uppercase text-secondary fw-bold">
        Localisation :
      </span>
      <span class="ms-5" spanaddressinputtest-id="spanaddressinputtest-id">
        {{ addressInput }}
      </span>
    </div>
  </div>
</div>
